<form   [formGroup]="myWelcome"
        (ngSubmit)="submitWelcome()"
        autocomplete="off">
    <div class="row justify-content-center position-relative">
        <!-- FIELD # 1 -->
        <input  class="input-box fs-4 fw-bold text-center font-box"
                formControlName="txt1"
                [ngClass]="{'is-invalid': submitted && myWelcome.controls.txt1.errors} "
                type="text"
                maxlength="1"
                autocomplete="off"
                oninput="this.nextElementSibling.focus()"
                (keydown)="onKeydown($event)">
                
        <!-- FIELD # 2 -->
        <input  class="input-box fs-4 fw-bold text-center font-box"
                formControlName="txt2"
                [ngClass]="{'is-invalid': submitted && myWelcome.controls.txt2.errors} "
                type="text"
                maxlength="1"
                autocomplete="off"
                oninput="this.nextElementSibling.focus()"
                (keydown)="onKeydown($event)">
                
        <!-- FIELD # 3 -->
        <input  class="input-box fs-4 fw-bold text-center font-box"
                formControlName="txt3"
                [ngClass]="{'is-invalid': submitted && myWelcome.controls.txt3.errors} "
                type="text"
                maxlength="1"
                autocomplete="off"
                oninput="this.nextElementSibling.focus()"
                (keydown)="onKeydown($event)">
                
        <!-- FIELD # 4 -->
        <input  class="input-box fs-4 fw-bold text-center font-box"
                formControlName="txt4"
                [ngClass]="{'is-invalid': submitted && myWelcome.controls.txt4.errors} "
                type="text"
                maxlength="1"
                autocomplete="off"
                (keydown)="onKeydown($event)"
                oninput="document.getElementById('submitButton').focus()">

        <span class="col-8 invalid-tooltip text-start"
              *ngIf="validacionCampo()" >
              {{ txtErrorsMsg | translate }} validación
        </span>
        <span class="col-8 invalid-tooltip text-start"
              *ngIf="true" >
              {{ txtErrorsMsg | translate }} 
        </span>
    </div>
    <br>

    <!-- INFO FOOT-->
    <div class="row justify-content-center">
        
        <!-- TXT 1 -->
        <!-- <div class="col-10">
            <p class="text-center font-primary">{{'signup.footer1' | translate }}<a routerLink="/auth/resend-code" class="font-primary">{{'signup.resend' | translate }}</a></p>
        </div> -->

        <!-- TXT 2 -->
        <!-- <div class="col-10">
        <p class="text-center font-primary"> {{'signup.footer2' | translate }} <a routerLink="/auth/property-search" class="font-primary">{{'signup.property' | translate }}</a></p>
        </div> -->
    </div>

    <!-- BUTTONS -->
    <div class="text-center mb-4">
        <button type="button"
                class="btn-secondary-gbl"
                routerLink="/auth/login">

            {{ 'user.back' | translate | uppercase }}
        </button>
        <button class="btn-primary-gbl"
                (click)="submitWelcome()"
                id="submitButton"
                type="button">

            {{ 'confirm_client.buttons.next' | translate | uppercase }}
        </button> 
    </div>
</form>
